import * as type from './types';

export function setSeletedTypes(data) {
    return {
        type: type.STORE_SELECTED_TYPES_REQUESTED,
        data: data,
    }
}